import { compose, lifecycle } from 'recompose';

import { LOCATIONS_ALL_ID } from '../../constants';

const withAllLocationsTab = compose(
  lifecycle({
    componentDidMount() {
      const { selectedLocation, setSelectedLocation, locationSelectorOptions } = this.props;

      const allLocationsExists = locationSelectorOptions.some((option) => option.value === LOCATIONS_ALL_ID);

      if (allLocationsExists && selectedLocation && selectedLocation !== LOCATIONS_ALL_ID) {
        setSelectedLocation(LOCATIONS_ALL_ID);
      }
    },
  })
);

export default withAllLocationsTab;
